var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wp_img"},[_c('img',{attrs:{"src":_vm.img[0]}}),_c('img',{attrs:{"src":_vm.img[1]}})])}
var staticRenderFns = []

export { render, staticRenderFns }